require('./style.less');

var Backbone = require('backbone'),
    $ = require('jquery'),
    PreventDragEventsMixin = require('../../preventDragEventsMixin');

var instVars = {
    parent: null,
    model: null,
    textGridModel: null,
    chrWt: 0,
    chrHt: 0
};

var TESTING = 0; /* show indicators via css */

if (PRODUCTION)
    TESTING = 0;

module.exports = Backbone.View.extend({

    className: 'textOverlay',

    initialize: function(options) {

        _.extend( this, instVars, _.pick( options, 'parent', 'model', 'textGridModel') );


        /* Unscaled: cached  for performance */
        this.chrWt = this.textGridModel.chrWt;
        this.chrHt = this.textGridModel.chrHt;

        this.listenTo( this.parent, 'scaleColdText', this.render );

    },
    //TODO: take greenbar out of render call
    render: function( scale, showGreenBar ) {

        this.$el.empty();
        this._printText(scale);
        this._formatEl(scale);
        TESTING && this.$el.addClass('testing');
        showGreenBar && this.$el.addClass('greenBar');
        return this;

    },
    //TODO --  subscriber
    toggleGreenBar: function() {
        this.$el.toggleClass('greenBar');
    },
    /**
     * Stop propagation of grabby hand drag events from the mode container to allow selection of the text.
     * Note: these mouseevents are no longer captured here were drawing atop the canvas.
     */
    events: PreventDragEventsMixin,

    onMouseDown: function(e) {
        e.stopPropagation();
    },
    onMouseMove: function(e) {
        e.stopPropagation();
    },
    onMouseUp: function(e) {
        e.stopPropagation();
    },

    _formatEl: function( scale ) {

        var attrs = this.model.get('overlay'),
            actualDims = this.textGridModel.actualDimensions( scale ),
            format = {
                top: attrs.yTextOffset * scale + 'in', //(must have position) --- don't use padding/margin
                left: attrs.xTextOffset * scale + 'in',
                'font-family': attrs.fontName,
                'font-size':  attrs.fontSize  * scale +  'pt',
                'line-height':  this.chrHt * scale + 'px', //note: would think not necessary anymore but it is!!!! -- DVBC-1162
                width: actualDims.width + 'px',   // not necessarily needed ...
                height: actualDims.height + 'px'
            };

        this.$el.css(format);

    },

    _printText: function(scale, $container) {

        var aRowDivs = this.textGridModel.textInNonDOMMarkup,
            chrW = this.chrWt * scale + 'px',
            chrH = this.chrHt * scale + 'px',
            appendToContainer = $container ? $container[0] : this.el,
            fragment = document.createDocumentFragment(),
            nRows = aRowDivs.length;

        // set the height and width of each element
        for ( var r=0; r < nRows; r++) {
            var curRowDiv = aRowDivs[r];
            curRowDiv.style['height'] = chrH; //now inheriting from line-height of $el (1em)

            var rowCharSpans = curRowDiv.childNodes,
                nCols = rowCharSpans.length;

            for (var c=0; c < nCols; c++) {
                rowCharSpans[c].style['width'] = chrW;
            }
            fragment.appendChild(curRowDiv);
        }

        appendToContainer.appendChild (fragment.cloneNode(true) );

    },

    //TODO:
    onBeforeDestroy: function() {

        //console.log('text overlay on destroy');
    }

});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/overlay/textOverlay/textOverlay.js
 ** module id = 468
 ** module chunks = 0
 **/